import { ContentSourceDetailsFragment } from "~/graphqlTypes/ContentSourceDetailsFragment";
import { AudioFileAvailabilityInput } from "~/graphqlTypes/globalTypes";

export function streamingRightFragmentToInput(
  right: ContentSourceDetailsFragment['defaultRights'][number],
): AudioFileAvailabilityInput {
  return {
    countryAvailability: {
      mode: right.countryAvailability.mode,
      countriesAndDates: ( right.countryAvailability.countriesAndDates || [] ).map( ( { country: { code } } ) => ( {
        country: { code },
      } ) ),
    },
    streamingRight: right.streamingRights.name,
  };
}
